<template>
    <div>
        <div class="dx-field">
            <div class="dx-field-label">Планируемое окончание</div>
            <div class="dx-field-value">
                <dx-date-box :value="data?.planned_end_date" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { inject } from 'vue';
import { DxDateBox } from 'devextreme-vue';

const data = inject('data');
</script>
